import { useState } from 'react';
import './AdminPanel.scss';
import useLocale from '../../locale/useLocale';
import useTitle from '../../helpers/useTitle';
import UsersTable from '../../components/pages/admin/management/shared/UsersTable';
import EngagementManagement from '../EngagementManagement';
import Tabs, { TabConfig } from '../../components/reusables/Tabs';

const managementTabs: TabConfig[] = [
    { label: 'Engagements', value: 'engagements' },
    { label: 'Users', value: 'users' },
];

const Management = () => {
    const { l } = useLocale();
    useTitle(l('_management'));
    const [activeTab, setActiveTab] = useState('engagements');

    return (
        <div className="admin-management">
            <Tabs
                tabs={managementTabs}
                onChange={(_index, value) => setActiveTab(value)}
            />

            {activeTab === 'engagements' ? (
                <EngagementManagement />
            ) : (
                <UsersTable />
            )}
        </div>
    );
};

export default Management;
